<template>
  <v-menu
    offset-y
    max-width="300"
    :close-on-content-click="false"

    v-model="isPickerMenuVisible"
    v-bind="menuProps"
  >
    <template v-slot:activator="{ attrs: menuAttrs, on: menuEvents }">
      <v-text-field
        v-bind="{ ...$attrs, ...menuAttrs }"
        v-on="{ ...$listeners, ...menuEvents }"

        readonly
        :value="formattedValue"
      />
    </template>

    <template v-slot:default>
      <v-date-picker
        v-bind="pickerProps"

        no-title
        full-width

        locale="pt-BR"
        :value="value"

        @input="(value) => updateValue(value)"
        @change="(value) => updateValue(value, 'change')"
      />
    </template>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerField',

  inheritAttrs: false,

  props: {
    value: {
      type: String,
      default: '',
    },

    menuProps: {
      type: Object,
      default: () => ({}),
    },

    pickerProps: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    isPickerMenuVisible: false,
  }),

  computed: {
    formattedValue: (vm) => {
      if (!vm.value) {
        return '';
      }

      const [year, month, day] = vm.value.split('-').map((num) => Number.parseInt(num, 10));

      return (new Date(year, month - 1, day)).toLocaleDateString('pt-BR');
    },
  },

  methods: {
    updateValue(value, event = 'input') {
      this.isPickerMenuVisible = false;

      this.$emit(event, value);
    },
  },
};
</script>
